import { setUserSessionPayload } from "../slices/otpAuthSlice";
import { store } from "../stores/store";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import moment from "moment";

// ✅ Save token in cookie
export const saveToken = ({ token, refreshToken }) => {
  try {
    console.log("tokens", token, refreshToken);
    Cookies.set("token", token, {
      expires: 7, // Expires in 7 days
      secure: true, // Works only over HTTPS
      sameSite: "strict", // Prevent CSRF attacks
      path: "/", // Accessible site-wide
    });

    Cookies.set("refreshToken", refreshToken, {
      expires: 7, // Expires in 7 days
      secure: true, // Works only over HTTPS
      sameSite: "strict", // Prevent CSRF attacks
      path: "/", // Accessible site-wide
    });
  } catch (error) {
    console.log("Error in saveToken:", error);
  }
};

// ✅ Get token from cookie
export const getToken = (key) => {
  try {
    const token = Cookies.get(key);
    console.log("Token:", token);
    return token;
  } catch (error) {
    console.log("Error in getToken:", error);
    return null;
  }
};

// ✅ Decode token payload (from cookie)
export const getTokenPayload = (key) => {
  try {
    const token = getToken(key); // get from cookie
    const payload = token ? jwt_decode(token) : {};
    console.log("Payload:", payload);
    return payload;
  } catch (error) {
    console.log("Error in getTokenPayload:", error);
    return {};
  }
};

// ✅ Remove token from cookie
export const removeToken = () => {
  try {
    Cookies.remove("token");
    Cookies.remove("refreshToken");
    console.log("Token removed");
  } catch (error) {
    console.log("Error in removeToken:", error);
  }
};

// ✅ Check token expiry
export const checkTokenExpiry = () => {
  try {
    const token = Cookies.get("token");
    const payload = getTokenPayload("token");
    const { exp } = payload;

    if (!token || !exp) {
      store.dispatch(
        setUserSessionPayload({ ...payload, isTokenExpired: true }),
      );
      return null;
    }

    const expiryTime = moment.unix(exp);
    const now = moment();

    if (now.isAfter(expiryTime)) {
      console.log("Token is expired please login");
      removeToken();
      store.dispatch(
        setUserSessionPayload({ ...payload, isTokenExpired: true }),
      );
      return null;
    } else {
      store.dispatch(setUserSessionPayload({ ...payload, isTokenExpired: false }));
    }

    return token;
  } catch (err) {
    throw err;
  }
};

// ✅ Remove token from cookie and logout
export const removeTokenAndLogout = () => {
  try {
    removeToken();
    if (typeof window !== undefined) window.location.href = "/";
    console.log("Token removed");
  } catch (error) {
    console.log("Error in removeToken:", error);
  }
};
